// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".userInfo[data-v-9953e8a0],.userName[data-v-9953e8a0]{margin-top:-20px}.userName[data-v-9953e8a0]{color:#8237dc;font-weight:700;font-size:20px}.userInfo[data-v-9953e8a0]{font-size:16px}.userTitle[data-v-9953e8a0]{color:#471782}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
